import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";
import Select from "react-select";

function BankAccountMaster() {
  // Add form state
  const [addAccountHolderName, setAddAccountHolderName] = useState("");
  const [addBankName, setAddBankName] = useState("");
  const [addBranch, setAddBranch] = useState("");
  const [addAccountNumber, setAddAccountNumber] = useState("");
  const [addIfscCode, setAddIfscCode] = useState("");
  const [addSwiftCode, setAddSwiftCode] = useState("");
  const [addIban, setAddIban] = useState("");
  const [addCurrency, setAddCurrency] = useState("");
  const [addBelongsTo, setAddBelongsTo] = useState("");
  const [addAddress, setAddAddress] = useState("");
  const [addStatus, setAddStatus] = useState("ACTIVE");
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [agentData, setAgentData] = useState([]);
  const [sharedWithData, setSharedWithData] = useState([]);
  const [accountSharedWithData, setAccountSharedWithData] = useState([]);
  const [sharedWithDataPending, setSharedWithDataPending] = useState(true);
  const [currencyData, setCurrencyData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteSharedWithModal, setShowDeleteSharedWithModal] =
    useState(false);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasFullScreen, setCanvasFullScreen] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);
  const [updateSharedWithLoader, setUpdateSharedWithLoader] = useState(false);
  const [showDeleteSharedWithLoader, setShowDeleteSharedWithLoader] =
    useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);
  const [recordForSharedWithDelete, setRecordForSharedWithDelete] =
    useState(null);

  const [showAccountHolderNameError, setShowAccountHolderNameError] =
    useState(false);
  const [showBankNameError, setShowBankNameError] = useState(false);
  const [showBranchError, setShowBranchError] = useState(false);
  const [showAccountNumberError, setShowAccountNumberError] = useState(false);
  const [showIfscCodeError, setShowIfscCodeError] = useState(false);
  const [showSwiftCodeError, setShowSwiftCodeError] = useState(false);
  const [showIbanError, setShowIbanError] = useState(false);
  const [showAddressError, setShowAddressError] = useState(false);

  const [
    showUpdateAccountHolderNameError,
    setShowUpdateAccountHolderNameError,
  ] = useState(false);
  const [showUpdateBankNameError, setShowUpdateBankNameError] = useState(false);
  const [showUpdateBranchError, setShowUpdateBranchError] = useState(false);
  const [showUpdateAccountNumberError, setShowUpdateAccountNumberError] =
    useState(false);
  const [showUpdateIfscCodeError, setShowUpdateIfscCodeError] = useState(false);
  const [showUpdateSwiftCodeError, setShowUpdateSwiftCodeError] =
    useState(false);
  const [showUpdateIbanError, setShowUpdateIbanError] = useState(false);
  const [showUpdateAddressError, setShowUpdateAddressError] = useState(false);

  const [updateId, setUpdateId] = useState("");
  const [updateAccountHolderName, setUpdateAccountHolderName] = useState("");
  const [updateBankName, setUpdateBankName] = useState("");
  const [updateBranch, setUpdateBranch] = useState("");
  const [updateAccountNumber, setUpdateAccountNumber] = useState("");
  const [updateIfscCode, setUpdateIfscCode] = useState("");
  const [updateSwiftCode, setUpdateSwiftCode] = useState("");
  const [updateIban, setUpdateIban] = useState("");
  const [updateCurrency, setUpdateCurrency] = useState("");
  const [updateBelongsTo, setUpdateBelongsTo] = useState("");
  const [updateAddress, setUpdateAddress] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [updateSharedWith, setUpdateSharedWith] = useState([]);
  const [updateSharedWithIds, setUpdateSharedWithIds] = useState([]);

  // ADD form
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // UPDATE form
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  const [showUpdateBankAccountDetails, setShowUpdateBankAccountDetails] =
    useState(true);
  const [showUpdateSharedWithDetails, setShowUpdateSharedWithDetails] =
    useState(false);

  const getLoggenInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      if (response) {
        setLoggedInUser(response.data);
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getBankAccount = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/bankaccount/",
      );
      setTimeout(() => {
        if (response) {
          setData(response.data);
          setDataPending(false);
        }
      }, 500);
    } catch (err) {
      toast.error("Error in fetching bank account data! Try again.");
    }
  };

  const getAgent = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/agent/",
      );
      setTimeout(() => {
        if (response) {
          setAgentData(response.data);
          const agent_array = [];
          for (let i = 0; i < response.data.length; i++) {
            const agent_dict = {};
            agent_dict["value"] = response.data[i]?.["id"];
            agent_dict["label"] =
              response.data[i]?.["name"] +
              " (" +
              response.data[i]?.["customer_branch_data"]["port_data"]["name"] +
              " : " +
              response.data[i]?.["customer_branch_data"]["customer_data"][
                "name"
              ] +
              ")";
            agent_array.push(agent_dict);
          }
          setSharedWithData(agent_array);
        }
      }, 500);
    } catch (err) {
      toast.error("Error in fetching agent data! Try again.");
    }
  };

  const getCurrency = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/currency/",
      );
      setTimeout(() => {
        if (response) {
          setCurrencyData(response.data);
        }
      }, 500);
    } catch (err) {
      toast.error("Error in fetching agent data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );

      const role_permissions_array = [];
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }

      if (role_permissions_array) {
        setCurrentUserRolePermissionData(role_permissions_array);
      }
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false);
  };

  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const handleSetAddData = () => {
    setAddAccountHolderName("");
    setAddBankName("");
    setAddBranch("");
    setAddAccountNumber("");
    setAddIfscCode("");
    setAddSwiftCode("");
    setAddIban("");
    setAddCurrency("");
    setAddBelongsTo("");
    setAddAddress("");
    setAddStatus("ACTIVE");
    // Reset error states if any
    setShowAccountHolderNameError(false);
    setShowBankNameError(false);
    setShowBranchError(false);
    setShowAccountNumberError(false);
    setShowIfscCodeError(false);
    setShowSwiftCodeError(false);
    setShowIbanError(false);
    setShowAddressError(false);
  };

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateAccountHolderName(row.account_holder_name);
    setUpdateBankName(row.bank_name);
    setUpdateBranch(row.branch);
    setUpdateAccountNumber(row.account_number);
    setUpdateIfscCode(row.ifsc_code);
    setUpdateSwiftCode(row.swift_code);
    setUpdateIban(row.iban);
    setUpdateCurrency(row.currency);
    setUpdateBelongsTo(row.belongs_to);
    setUpdateAddress(row.address);
    setUpdateStatus(row.status);

    setAccountSharedWithData(row.shared_with_data);
    setSharedWithDataPending(false);
    setIsUpdateValidationErrorVisible(false);
    setUpdateValidationErrorArray([]);
    setShowUpdateValidationError(false);
  };

  const handleResetUpdateData = () => {
    setUpdateId("");
    setUpdateAccountHolderName("");
    setUpdateBankName("");
    setUpdateBranch("");
    setUpdateAccountNumber("");
    setUpdateIfscCode("");
    setUpdateSwiftCode("");
    setUpdateIban("");
    setUpdateCurrency("");
    setUpdateBelongsTo("");
    setUpdateAddress("");
    setUpdateStatus("");
    setUpdateSharedWith([]);
    setUpdateSharedWithIds([]);
    // reset error states
    setShowUpdateAccountHolderNameError(false);
    setShowUpdateBankNameError(false);
    setShowUpdateBranchError(false);
    setShowUpdateAccountNumberError(false);
    setShowUpdateIfscCodeError(false);
    setShowUpdateSwiftCodeError(false);
    setShowUpdateIbanError(false);
    setShowUpdateAddressError(false);
    // reset validation
    setShowUpdateValidationError(false);
    setIsUpdateValidationErrorVisible(false);
    setUpdateValidationErrorArray([]);
    // reset tab
    setShowUpdateBankAccountDetails(true);
    setShowUpdateSharedWithDetails(false);
  };

  useEffect(() => {
    getLoggenInUser();
    getBankAccount();
    getAgent();
    getCurrency();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  const columns = [
    {
      name: "Account Holder",
      selector: (row) => row.account_holder_name,
      sortable: true,
    },
    {
      name: "Bank Name",
      selector: (row) => row.bank_name,
      sortable: true,
    },
    {
      name: "Branch",
      selector: (row) => row.branch,
      sortable: true,
    },
    {
      name: "Account Number",
      selector: (row) => row.account_number,
      sortable: true,
    },
    {
      name: "IFSC Code",
      selector: (row) => row.ifsc_code,
      sortable: true,
    },
    {
      name: "Swift Code",
      selector: (row) => row.swift_code,
      sortable: true,
    },
    {
      name: "IBAN",
      selector: (row) => row.iban,
      sortable: true,
    },
    {
      name: "Currency",
      selector: (row) => row.currency_data?.symbol,
      sortable: true,
    },
    {
      name: "Belongs To",
      selector: (row) => row.belongs_to_data?.name,
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => row.address,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes(
            "master:bankaccount:update",
          ) ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              data-bs-toggle="offcanvas"
              data-bs-target="#updateSection"
              onClick={() => handleSetUpdateData(row)}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}

          {currentUserRolePermissionData?.includes(
            "master:bankaccount:delete",
          ) ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/bankaccount/" +
          id +
          "/",
      );
      setShowDeleteModal(false);
      getBankAccount();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    getBankAccount();
    setShowDeleteLoader(false);
  };

  const addNewBankAccount = async (e) => {
    e.preventDefault();
    // Validation using state
    setShowAccountHolderNameError(!addAccountHolderName);
    setShowBankNameError(!addBankName);
    setShowBranchError(!addBranch);
    setShowAccountNumberError(!addAccountNumber);
    setShowIfscCodeError(!addIfscCode);
    setShowSwiftCodeError(!addSwiftCode);
    setShowIbanError(!addIban);
    setShowAddressError(!addAddress);

    if (
      !addAccountHolderName ||
      !addBankName ||
      !addBranch ||
      !addAccountNumber ||
      !addIfscCode ||
      !addSwiftCode ||
      !addIban ||
      !addAddress
    ) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const data = {
      account_holder_name: addAccountHolderName,
      bank_name: addBankName,
      branch: addBranch,
      account_number: addAccountNumber,
      ifsc_code: addIfscCode,
      swift_code: addSwiftCode,
      iban: addIban,
      currency: addCurrency,
      belongs_to: addBelongsTo,
      address: addAddress,
      status: addStatus,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/master/bankaccount/",
        data,
        { headers: { "content-type": "application/json" } },
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Bank Account Created Successfully");
        handleSetAddData(); // reset form
        setShowAddCanvas(false);
        getBankAccount();
      }
    } catch (err) {
      toast.error("Error creating bank account");
    } finally {
      setShowAddLoader(false);
    }
  };
  const updateBankAccount = async (e) => {
    e.preventDefault();
    setShowUpdateAccountHolderNameError(updateAccountHolderName === "");
    setShowUpdateBankNameError(updateBankName === "");
    setShowUpdateBranchError(updateBranch === "");
    setShowUpdateAccountNumberError(updateAccountNumber === "");
    setShowUpdateIfscCodeError(updateIfscCode === "");
    setShowUpdateSwiftCodeError(updateSwiftCode === "");
    setShowUpdateIbanError(updateIban === "");
    setShowUpdateAddressError(updateAddress === "");

    if (
      !updateAccountHolderName ||
      !updateBankName ||
      !updateBranch ||
      !updateAccountNumber ||
      !updateIfscCode ||
      !updateSwiftCode ||
      !updateIban ||
      !updateAddress
    ) {
      return;
    }

    setShowUpdateLoader(true);

    const id = updateId;

    const data = {
      account_holder_name: updateAccountHolderName,
      bank_name: updateBankName,
      branch: updateBranch,
      account_number: updateAccountNumber,
      ifsc_code: updateIfscCode,
      swift_code: updateSwiftCode,
      iban: updateIban,
      currency: updateCurrency,
      belongs_to: updateBelongsTo,
      address: updateAddress,
      status: updateStatus,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    const response = await axios.put(
      process.env.REACT_APP_BACKEND_API_URL + "/master/bankaccount/" + id + "/",
      data,
      {
        headers: { "content-type": "application/json" },
      },
    );
    if (response.status === 200) {
      toast.success("Bank Account updated Successfully");
    }
    getBankAccount();
    setShowUpdateCanvas(false);
    setShowUpdateLoader(false);
  };

  const sharedwithcolumns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Customer",
      selector: (row) => row.customer_branch_data?.customer_data?.name,
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => row.customer_branch_data?.port_data?.name,
      sortable: true,
    },
    {
      name: "Address",
      width: "600px",
      selector: (row) =>
        row.address_line_1 +
        ", " +
        row.address_line_2 +
        ", " +
        row.city +
        ", " +
        row.state +
        ", " +
        row.pincode,
      sortable: true,
    },
    {
      name: "Own Office",
      selector: (row) => row.own_office,
      sortable: true,
    },
    {
      name: "Country",
      center: true,
      selector: (row) => (
        <div className="text-center">
          <img
            src={row.country_data?.image_url}
            height={20}
            width={35}
            style={{ marginBottom: 5 }}
          ></img>
          <br></br>
          <span>{row.country_data?.long_name}</span>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes(
            "master:bankaccount:delete",
          ) ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteSharedWithModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const selectedSharedWithForUpdate = (agentdata) => {
    if (agentdata.length > 0) {
      const agentarray = [];
      for (let i = 0; i < agentdata.length; i++) {
        agentarray.push(agentdata[i]["value"]);
      }
      setUpdateSharedWith(agentdata);
      setUpdateSharedWithIds(agentarray);
    } else {
      setUpdateSharedWith([]);
      setUpdateSharedWithIds([]);
    }
  };

  const updateSharedWithAgent = async (e) => {
    e.preventDefault();
    setUpdateSharedWithLoader(true);

    const id = updateId;

    const data = {
      id: id,
      shared_with: updateSharedWithIds,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    const response = await axios.put(
      process.env.REACT_APP_BACKEND_API_URL +
        "/master/bankaccount/shareaccountdetails/",
      data,
      {
        headers: { "content-type": "application/json" },
      },
    );

    if (response.status === 200) {
      toast.success("Account Details Shared Successfully");
    }

    setAccountSharedWithData(response.data.shared_with_data);
    getBankAccount();
    setShowUpdateCanvas(false);
    setUpdateSharedWithLoader(false);
  };

  const handleDeleteSharedWithModalClose = () => {
    setShowDeleteSharedWithModal(false);
  };

  const handleDeleteSharedWithModalOpen = (data) => {
    setShowDeleteSharedWithModal(true);
    setRecordForSharedWithDelete(data);
  };

  const deleteSelectedSharedWithRecord = async (agent_id) => {
    setShowDeleteSharedWithLoader(true);
    try {
      const data = {
        id: updateId,
        agent: agent_id,
      };
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/bankaccount/deletesharedwithagent/",
        data,
        {
          headers: { "content-type": "application/json" },
        },
      );

      if (response.status === 200) {
        toast.success("Record removed from shared list");
        setAccountSharedWithData(response.data.shared_with_data);
        getBankAccount();
        setShowDeleteSharedWithModal(false);
      }
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }

    getBankAccount();
    setShowDeleteSharedWithLoader(false);
    setShowDeleteSharedWithModal(false);
  };

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  const hasAnyAddError = () => {
    return (
      showAccountHolderNameError ||
      showBankNameError ||
      showBranchError ||
      showAccountNumberError ||
      showIfscCodeError ||
      showSwiftCodeError ||
      showIbanError ||
      showAddressError
    );
  };

  const hasAnyUpdateError = () => {
    return (
      showUpdateAccountHolderNameError ||
      showUpdateBankNameError ||
      showUpdateBranchError ||
      showUpdateAccountNumberError ||
      showUpdateIfscCodeError ||
      showUpdateSwiftCodeError ||
      showUpdateIbanError ||
      showUpdateAddressError
    );
  };

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!addAccountHolderName) errors.push("Account Holder Name is required");
    if (!addBankName) errors.push("Bank Name is required");
    if (!addBranch) errors.push("Branch is required");
    if (!addAccountNumber) errors.push("Account Number is required");
    if (!addIfscCode) errors.push("IFSC Code is required");
    if (!addSwiftCode) errors.push("Swift Code is required");
    if (!addIban) errors.push("IBAN is required");
    if (!addAddress) errors.push("Address is required");
    return errors;
  };

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateAccountHolderName)
      errors.push("Account Holder Name is required");
    if (!updateBankName) errors.push("Bank Name is required");
    if (!updateBranch) errors.push("Branch is required");
    if (!updateAccountNumber) errors.push("Account Number is required");
    if (!updateIfscCode) errors.push("IFSC Code is required");
    if (!updateSwiftCode) errors.push("Swift Code is required");
    if (!updateIban) errors.push("IBAN is required");
    if (!updateAddress) errors.push("Address is required");
    return errors;
  };

  const handleCheckValidationClick = () => {
    setValidationErrorArray(buildAddErrorMessages());
    setIsValidationErrorVisible(!isValidationErrorVisible);
  };

  const handleUpdateCheckValidationClick = () => {
    setUpdateValidationErrorArray(buildUpdateErrorMessages());
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);
  };

  return (
    <div className="page-content-bg">
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="BankAccountMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Bank Account Master</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes(
                "master:customer:add",
              ) ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0  px-3 float-right"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#addSection"
                  onClick={() => {
                    handleSetAddData();
                    setIsValidationErrorVisible(false);
                    setValidationErrorArray([]);
                    setShowValidationError(false);
                  }}
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Bank Account</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="sm"
        show={showDeleteSharedWithModal}
        onHide={handleDeleteSharedWithModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleDeleteSharedWithModalClose}
          >
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() =>
              deleteSelectedSharedWithRecord(recordForSharedWithDelete?.id)
            }
          >
            {showDeleteSharedWithLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div
        class={
          canvasFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        id="updateSection"
        data-bs-scroll="true"
        tabindex="-1"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Update Record
              </h4>
              <Button
                className={`${showUpdateBankAccountDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => [
                  setShowUpdateBankAccountDetails(true),
                  setShowUpdateSharedWithDetails(false),
                ]}
              >
                Details
              </Button>

              <Button
                className={`${showUpdateSharedWithDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => [
                  setShowUpdateBankAccountDetails(false),
                  setShowUpdateSharedWithDetails(true),
                ]}
              >
                Shared With
              </Button>
            </div>
            <div className="col-6">
              <button
                type="button"
                class="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={() => {
                  setShowUpdateCanvas(false);
                  handleResetUpdateData();
                  setIsUpdateValidationErrorVisible(false);
                  setUpdateValidationErrorArray([]);
                }}
              >
                <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen ? (
                <button
                  type="button"
                  class="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  class="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          class="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          {showUpdateBankAccountDetails ? (
            <div>
              <form onSubmit={(e) => updateBankAccount(e)}>
                <div className="row">
                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" for="account_holder_name">
                      Account Holder Name:
                      <span className="text-danger">
                        {showUpdateAccountHolderNameError
                          ? "Name required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="account_holder_name"
                      name="account_holder_name"
                      placeholder="Enter Name"
                      value={updateAccountHolderName}
                      onChange={(e) => {
                        setUpdateAccountHolderName(e.target.value);
                        if (e.target.value !== "")
                          setShowUpdateAccountHolderNameError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) =>
                        e.target.value == ""
                          ? setShowUpdateAccountHolderNameError(true)
                          : setShowUpdateAccountHolderNameError(false)
                      }
                    />
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" for="bank_name">
                      Bank Name:
                      <span className="text-danger">
                        {showUpdateBankNameError ? "Bank Name required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="bank_name"
                      name="bank_name"
                      placeholder="Enter Bank Name"
                      value={updateBankName}
                      onChange={(e) => {
                        setUpdateBankName(e.target.value);
                        if (e.target.value !== "")
                          setShowUpdateBankNameError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) =>
                        e.target.value == ""
                          ? setShowUpdateBankNameError(true)
                          : setShowUpdateBankNameError(false)
                      }
                    />
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" for="branch">
                      Branch:
                      <span className="text-danger">
                        {showUpdateBranchError ? "Branch required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="branch"
                      name="branch"
                      placeholder="Enter Branch"
                      value={updateBranch}
                      onChange={(e) => {
                        setUpdateBranch(e.target.value);
                        if (e.target.value !== "")
                          setShowUpdateBranchError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) =>
                        e.target.value == ""
                          ? setShowUpdateBranchError(true)
                          : setShowUpdateBranchError(false)
                      }
                    />
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" for="account_number">
                      Account Number:
                      <span className="text-danger">
                        {showUpdateAccountNumberError
                          ? "Account Number required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="account_number"
                      name="account_number"
                      placeholder="Enter Account Number"
                      value={updateAccountNumber}
                      onChange={(e) => {
                        setUpdateAccountNumber(e.target.value);
                        if (e.target.value !== "")
                          setShowUpdateAccountNumberError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) =>
                        e.target.value == ""
                          ? setShowUpdateAccountNumberError(true)
                          : setShowUpdateAccountNumberError(false)
                      }
                    />
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" for="ifsc_code">
                      IFSC Code:
                      <span className="text-danger">
                        {showUpdateIfscCodeError ? "IFSC Code required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="ifsc_code"
                      name="ifsc_code"
                      placeholder="Enter IFSC Code"
                      value={updateIfscCode}
                      onChange={(e) => {
                        setUpdateIfscCode(e.target.value);
                        if (e.target.value !== "")
                          setShowUpdateIfscCodeError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) =>
                        e.target.value == ""
                          ? setShowUpdateIfscCodeError(true)
                          : setShowUpdateIfscCodeError(false)
                      }
                    />
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" for="swift_code">
                      Swift Code:
                      <span className="text-danger">
                        {showUpdateSwiftCodeError ? "Swift Code required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="swift_code"
                      name="swift_code"
                      placeholder="Enter Swift Code"
                      value={updateSwiftCode}
                      onChange={(e) => {
                        setUpdateSwiftCode(e.target.value);
                        if (e.target.value !== "")
                          setShowUpdateSwiftCodeError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) =>
                        e.target.value == ""
                          ? setShowUpdateSwiftCodeError(true)
                          : setShowUpdateSwiftCodeError(false)
                      }
                    />
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" for="iban">
                      IBAN:
                      <span className="text-danger">
                        {showUpdateIbanError ? "IBAN required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="iban"
                      name="iban"
                      placeholder="Enter IBAN"
                      value={updateIban}
                      onChange={(e) => {
                        setUpdateIban(e.target.value);
                        if (e.target.value !== "")
                          setShowUpdateIbanError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) =>
                        e.target.value == ""
                          ? setShowUpdateIbanError(true)
                          : setShowUpdateIbanError(false)
                      }
                    />
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label for="currency">Currency: </label>
                    <select
                      name="currency"
                      class="form-control form-control-sm"
                      onChange={(e) => setUpdateCurrency(e.target.value)}
                    >
                      <option value="">Select Currency</option>
                      {currencyData.map((currency) => (
                        <option
                          value={currency?.id}
                          selected={
                            updateCurrency == currency.id ? true : false
                          }
                        >
                          {currency?.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label for="belongs_to">Belongs To: </label>
                    <select
                      name="belongs_to"
                      class="form-control form-control-sm"
                      onChange={(e) => setUpdateBelongsTo(e.target.value)}
                    >
                      <option value="">Select Owner</option>
                      {agentData.map((agent) => (
                        <option
                          value={agent?.id}
                          selected={updateBelongsTo == agent.id ? true : false}
                        >
                          {agent?.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" for="address">
                      Address:
                      <span className="text-danger">
                        {showUpdateAddressError ? "Address required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="address"
                      name="address"
                      placeholder="Enter Address"
                      value={updateAddress}
                      onChange={(e) => {
                        setUpdateAddress(e.target.value);
                        if (e.target.value !== "")
                          setShowUpdateAddressError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) =>
                        e.target.value == ""
                          ? setShowUpdateAddressError(true)
                          : setShowUpdateAddressError(false)
                      }
                    />
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label for="status">Status: </label>
                    <select
                      className="form-select form-control-sm"
                      name="status"
                      onChange={(e) => setUpdateStatus(e.target.value)}
                    >
                      <option
                        value="ACTIVE"
                        selected={updateStatus == "ACTIVE" ? true : false}
                      >
                        ACTIVE
                      </option>
                      <option
                        value="INACTIVE"
                        selected={updateStatus == "INACTIVE" ? true : false}
                      >
                        INACTIVE
                      </option>
                    </select>
                  </div>

                  <div
                    class={`form-group ${canvasFullScreen ? "col-md-12" : "col-md-12"}`}
                  >
                    <Button
                      className="btn btn-inox-green border-0 canvas-button"
                      onClick={(e) => updateBankAccount(e)}
                      disabled={hasAnyUpdateError() || showUpdateLoader}
                    >
                      {showUpdateLoader ? (
                        <Spinner
                          className="mx-4"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <>
                          <i className="fa fa-edit"></i>{" "}
                          <span className="mx-2">Update</span>
                        </>
                      )}
                    </Button>

                    {(hasAnyUpdateError() || showUpdateValidationError) && (
                      <div className="error-tooltip-wrapper">
                        <Button
                          style={{
                            backgroundColor: "#C21E22",
                            border: "#f82e2e",
                          }}
                          title="Show Errors"
                          className="mx-2"
                          onClick={handleUpdateCheckValidationClick}
                          onMouseLeave={() =>
                            setIsUpdateValidationErrorVisible(false)
                          }
                        >
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {isUpdateValidationErrorVisible && (
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {updateValidationErrorArray.map(
                                (error, index) => (
                                  <li
                                    key={index}
                                    className="text-left small pb-0"
                                  >
                                    {error}
                                  </li>
                                ),
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          ) : (
            ""
          )}

          {showUpdateSharedWithDetails ? (
            <div>
              <div className="row">
                <div
                  class={`form-group ${canvasFullScreen ? "col-md-8" : "col-md-10"} text-left mb-4`}
                >
                  <label for="shared_with">Shared With:</label>
                  <Select
                    options={sharedWithData}
                    className="zindex-1000"
                    id="shared_with"
                    name="shared_with"
                    onChange={(e) => selectedSharedWithForUpdate(e)}
                    maxMenuHeight={canvasFullScreen ? 1000 : 200}
                    value={updateSharedWith}
                    isMulti
                    isClearable
                  />
                </div>

                <div
                  class={`form-group ${canvasFullScreen ? "col-md-4" : "col-md-2"} text-left mb-4`}
                >
                  <Button
                    className="btn btn-inox-green border-0 canvas-button mt-4"
                    onClick={(e) => updateSharedWithAgent(e)}
                  >
                    {updateSharedWithLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-edit"></i>{" "}
                        <span className="mx-2">Share</span>
                      </>
                    )}
                  </Button>
                </div>
              </div>

              <div
                className="col-12 text-left"
                style={{
                  marginTop: -5,
                  paddingLeft: 20,
                  paddingRight: 30,
                  zIndex: 100,
                }}
              >
                <DataTable
                  columns={sharedwithcolumns}
                  data={accountSharedWithData}
                  progressPending={sharedWithDataPending}
                  progressComponent={
                    <Spinner
                      className="mx-5 text-inox-green table-spinner"
                      as="span"
                      animation="border"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                    />
                  }
                  noDataComponent={
                    <p className="text-center table-no-data">
                      Not shared with Anyone
                    </p>
                  }
                  pagination
                  highlightOnHover
                  fixedHeader
                  customStyles={userTableCustomStyles}
                  dense
                />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}

      <div
        className={
          canvasFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        data-bs-scroll="true"
        tabIndex="-1"
        id="addSection"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Add New Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={() => {
                  setShowAddCanvas(false);
                  setIsValidationErrorVisible(false);
                  setValidationErrorArray([]);
                }}
              >
                <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={(e) => addNewBankAccount(e)}>
            <div className="row">
              {/* Account Holder Name */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label className="required-label" htmlFor="account_holder_name">
                  Account Holder Name:
                  <span className="text-danger">
                    {showAccountHolderNameError ? "Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="account_holder_name"
                  name="account_holder_name"
                  placeholder="Enter Name"
                  value={addAccountHolderName}
                  onChange={(e) => {
                    setAddAccountHolderName(e.target.value);
                    setShowAccountHolderNameError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAccountHolderNameError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Bank Name */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label className="required-label" htmlFor="bank_name">
                  Bank Name:
                  <span className="text-danger">
                    {showBankNameError ? "Bank Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="bank_name"
                  name="bank_name"
                  placeholder="Enter Bank Name"
                  value={addBankName}
                  onChange={(e) => {
                    setAddBankName(e.target.value);
                    setShowBankNameError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowBankNameError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Branch */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label className="required-label" htmlFor="branch">
                  Branch:
                  <span className="text-danger">
                    {showBranchError ? "Branch required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="branch"
                  name="branch"
                  placeholder="Enter Branch"
                  value={addBranch}
                  onChange={(e) => {
                    setAddBranch(e.target.value);
                    setShowBranchError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowBranchError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Account Number */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label className="required-label" htmlFor="account_number">
                  Account Number:
                  <span className="text-danger">
                    {showAccountNumberError ? "Account Number required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="account_number"
                  name="account_number"
                  placeholder="Enter Account Number"
                  value={addAccountNumber}
                  onChange={(e) => {
                    setAddAccountNumber(e.target.value);
                    setShowAccountNumberError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAccountNumberError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* IFSC Code */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label className="required-label" htmlFor="ifsc_code">
                  IFSC Code:
                  <span className="text-danger">
                    {showIfscCodeError ? "IFSC Code required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="ifsc_code"
                  name="ifsc_code"
                  placeholder="Enter IFSC Code"
                  value={addIfscCode}
                  onChange={(e) => {
                    setAddIfscCode(e.target.value);
                    setShowIfscCodeError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowIfscCodeError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Swift Code */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label className="required-label" htmlFor="swift_code">
                  Swift Code:
                  <span className="text-danger">
                    {showSwiftCodeError ? "Swift Code required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="swift_code"
                  name="swift_code"
                  placeholder="Enter Swift Code"
                  value={addSwiftCode}
                  onChange={(e) => {
                    setAddSwiftCode(e.target.value);
                    setShowSwiftCodeError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowSwiftCodeError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* IBAN */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label className="required-label" htmlFor="iban">
                  IBAN:
                  <span className="text-danger">
                    {showIbanError ? "IBAN required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="iban"
                  name="iban"
                  placeholder="Enter IBAN"
                  value={addIban}
                  onChange={(e) => {
                    setAddIban(e.target.value);
                    setShowIbanError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowIbanError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Currency */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label htmlFor="currency">Currency:</label>
                <select
                  name="currency"
                  className="form-control form-control-sm"
                  value={addCurrency}
                  onChange={(e) => setAddCurrency(e.target.value)}
                >
                  <option value="">Select Currency</option>
                  {currencyData.map((currency) => (
                    <option key={currency.id} value={currency.id}>
                      {currency.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Belongs To */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label htmlFor="belongs_to">Belongs To:</label>
                <select
                  name="belongs_to"
                  className="form-control form-control-sm"
                  value={addBelongsTo}
                  onChange={(e) => setAddBelongsTo(e.target.value)}
                >
                  <option value="">Select Owner</option>
                  {agentData.map((agent) => (
                    <option key={agent.id} value={agent.id}>
                      {agent.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Address */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label className="required-label" htmlFor="address">
                  Address:
                  <span className="text-danger">
                    {showAddressError ? "Address required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="address"
                  name="address"
                  placeholder="Enter Address"
                  value={addAddress}
                  onChange={(e) => {
                    setAddAddress(e.target.value);
                    setShowAddressError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowAddressError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Status */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-2" : "col-md-2"
                } text-left mb-4`}
              >
                <label htmlFor="status">Status:</label>
                <select
                  className="form-select form-control-sm"
                  name="status"
                  value={addStatus}
                  onChange={(e) => setAddStatus(e.target.value)}
                >
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>

              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${
                  canvasFullScreen ? "col-md-12" : "col-md-12"
                }`}
              >
                <Button
                  className="btn btn-inox-green border-0 canvas-button"
                  onClick={(e) => addNewBankAccount(e)}
                  disabled={hasAnyAddError() || showAddLoader}
                >
                  {showAddLoader ? (
                    <Spinner
                      className="mx-4"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <>
                      <i className="fa fa-plus"></i>{" "}
                      <span className="mx-2">Add</span>
                    </>
                  )}
                </Button>

                {(hasAnyAddError() || showValidationError) && (
                  <div className="error-tooltip-wrapper">
                    <Button
                      style={{
                        backgroundColor: "#C21E22",
                        border: "#f82e2e",
                      }}
                      title="Show Errors"
                      className="mx-2"
                      onClick={handleCheckValidationClick}
                      onMouseLeave={() => setIsValidationErrorVisible(false)}
                    >
                      <i className="fa fa-exclamation"></i>
                    </Button>
                    {isValidationErrorVisible && (
                      <div className="validation-error-tooltip">
                        <ul className="mb-0 px-4">
                          {validationErrorArray.map((error, index) => (
                            <li key={index} className="text-left small pb-0">
                              {error}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}
    </div>
  );
}

export default BankAccountMaster;
